module.exports = __webpack_public_path__ + "static/media/adobeStock.182ad7bb.png";